import React, {useEffect, useState} from "react";
import B2GReferralsModal from "./OuterComponents/B2GReferralsModal";
import B2GVisitsModal from "./OuterComponents/B2GVisitsModal";
import {Button, Col, Row, Spinner, Stack} from "react-bootstrap";
import {Popover} from "antd";
import Input from "../../../common/Input";
import axios from "axios";
import {toast} from "react-toastify";
import {useSelector} from "react-redux";

const MonthlyInvoicing = () => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [credentials, setCredentials] = useState({
        dapyUsername: "",
        dapyPassword: "",
    })
    const [loading, setLoading] = useState(false);
    const [showB2GReferralsModal, setShowB2GReferralsModal] = useState(false);
    const [showB2GVisitsModal, setShowB2GVisitsModal] = useState(false);

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/prescription/get-settings`, {
            headers: {"Content-Type": "application/json"},
            params: {
                company: company.id,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                if (res.data.settings) {
                    setCredentials({
                        dapyUsername: res.data.settings?.dapyUsername || "",
                        dapyPassword: res.data.settings?.dapyPassword || "",
                    });
                }
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση στοιχείων.")
        })
    }

    const saveDAPYCredentials = () => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/save-settings`, {
            company: company.id,
            settings: credentials,
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής αποθήκευση στοιχείων ΔΑΠΥ Ανοιχτής Περίθαλψης.");
            } else {
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    return (
        <React.Fragment>
            <Row>
                <Col md={4}>
                    <div style={{borderRadius: "16px", border: "2px solid lightgray", padding: "10px"}}>
                        <div className={"text-muted mb-1"}><i>Στοιχεία ΔΑΠΥ Ανοιχτής Περίθαλψης</i></div>
                        <Popover placement={"right"} content={
                            <div>
                                Το όνομα χρήστη που χρησιμοποιείτε για να συνδεθείτε στο eservices.eopyy.gov.gr
                            </div>
                        }>
                            <>
                                <Input
                                    className={"mb-2"}
                                    name={"dapyUsername"}
                                    label={"Όνομα Χρήστη"}
                                    value={credentials.dapyUsername}
                                    autoComplete={"off"}
                                    onChange={(e) => setCredentials({...credentials, dapyUsername: e.target.value})}
                                />
                            </>
                        </Popover>

                        <Popover placement={"right"} content={
                            <div>
                                Ο κωδικός που χρησιμοποιείτε για να συνδεθείτε στο eservices.eopyy.gov.gr
                            </div>
                        }>
                            <>
                                <Input
                                    className={"mb-2"}
                                    name={"dapyPassword"}
                                    label={"Κωδικός Χρήστη"}
                                    type={"password"}
                                    value={credentials.dapyPassword}
                                    autoComplete={"off"}
                                    onChange={(e) => setCredentials({...credentials, dapyPassword: e.target.value})}
                                    allowShowPassword={"true"}
                                />
                            </>
                        </Popover>
                        <div style={{textAlign: "center"}}>
                            <Button onClick={() => saveDAPYCredentials()} disabled={loading}>
                                Ενεργοποίηση {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                            </Button>
                        </div>
                        <div className={"text-muted mb-1 mt-2"}><i>Εργαλεία τιμολόγησης προς ΕΟΠΥΥ</i></div>
                        <div>
                            <Stack gap={1}>
                                <Button size={"sm"} onClick={() => setShowB2GVisitsModal(true)}>Δημιουργία πώλησης μηνός για τις επισκέψεις</Button>
                                <Button size={"sm"} onClick={() => setShowB2GReferralsModal(true)}>Δημιουργία πώλησης μηνός για τα παραπεμπτικά</Button>
                            </Stack>
                        </div>
                    </div>
                </Col>
            </Row>

            <B2GReferralsModal
                show={showB2GReferralsModal}
                setShow={setShowB2GReferralsModal}
            />
            <B2GVisitsModal
                show={showB2GVisitsModal}
                setShow={setShowB2GVisitsModal}
            />
        </React.Fragment>
    )
}

export default MonthlyInvoicing;
